import { useMutation } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';

type Options = {
  onPostImageSuccess?: () => void;
  onPostImageError?: (error: unknown) => void;
};

export function usePostFile(options?: Options) {
  const getApi = useApi();

  const postFile = async (image: File) => {
    const api = await getApi();

    const formData = new FormData();
    formData.append('file', image);

    const fileResponse = await api.filesUpload({
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return fileResponse.data;
  };

  const onSuccess = () => {
    options?.onPostImageSuccess?.();
  };

  const onError = (error: unknown) => {
    toast.error('Något gick fel, bilden gick inte att spara');
    options?.onPostImageError?.(error);
  };

  const mutation = useMutation(postFile, {
    onSuccess,
    onError,
  });

  return mutation;
}
